module.exports = __webpack_public_path__ + "static/undraw_business_plan_5i9d-00168e8c4815bdddaac7bc2ff935d9cb.svg";